import { makeStyles } from "@material-ui/core/styles";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { NotificationManager } from "react-notifications";
import MainService from "../../Common/MainService";
import "./MSMEDashboard.css";

const useStyles = makeStyles((theme) => ({
  gridRoot: {
    flexGrow: 1,
  },
  title: {
    fontSize: 14,
  },
}));

export default function MSMEDashboard() {
  const classes = useStyles();
  const [getMsmeCaid, setMsmeCaid] = useState("");
  const [getSchemesData, setSchemesData] = useState([]);
  const { user } = MainService.getLocalData();
  const { username, parentId } = user;
  const [getCategoriesList, setCategoriesList] = useState("");
  const [getFarmCategoriesList, setFarmCategoriesList] = useState("");
  const [getProductsLength, setProductsLength] = useState([]);
  const [getFarmProductsLength, setFarmProductsLength] = useState([]);
  const [getMSMEUsers, setMSMEUsers] = useState([]);
  const [getPMCUsers, setPMCUsers] = useState([]);
  const [getFMCUsers, setFMCUsers] = useState([]);

  const categorysList = () => {
    MainService.getListOfCategorys()
      .then((res) => {
        const filterCategory = res.filter((data) => {
          return data?.categoryname === "PROCESSING-MACHINERY";
        });
        const farmCategory = res.filter((data) => {
          return data?.categoryname === "FARM-MACHINERY";
        });
        setCategoriesList(filterCategory[0]?.categoryid);
        setFarmCategoriesList(farmCategory[0]?.categoryid);
      })
      .catch((err) => {
        return NotificationManager.error("something went wrong");
      });
  };

  useMemo(() => {
    categorysList();
  }, []);

  const getListOfCategorys = () => {
    MainService.getListOfCategorys()
      .then((data) => {
        const maseCategories = ["MSME_GOVT_SCHEMES"];
        const maseCategoriesFilter = data.filter((val) => {
          return maseCategories.includes(val.categoryname);
        });
        setMsmeCaid(maseCategoriesFilter[0]?.categoryid);
      })
      .catch((e) => {
        return NotificationManager.error("something went wrong");
      });
  };

  useMemo(() => {
    getListOfCategorys();
  }, []);

  const getProductsBasedonCategoryID = () => {
    MainService.getProductsBasedonCategoryID(getCategoriesList)
      .then((data) => {
        setProductsLength(data.products);
      })
      .catch((e) => {
        return NotificationManager.error("something went wrong");
      });
  };

  useEffect(() => {
    if (!getCategoriesList) return;
    getProductsBasedonCategoryID();
  }, [getCategoriesList]);

  const getFarmProductsBasedonCategoryID = () => {
    MainService.getProductsBasedonCategoryID(getFarmCategoriesList)
      .then((data) => {
        setFarmProductsLength(data.products);
      })
      .catch((e) => {
        return NotificationManager.error("something went wrong");
      });
  };

  useEffect(() => {
    if (!getFarmCategoriesList) return;
    getFarmProductsBasedonCategoryID();
  }, [getFarmCategoriesList]);

  const msmeSchemesHandler = () => {
    MainService.getCategoryContentBaedonCategoryid(getMsmeCaid)
      .then((data) => {
        setSchemesData(data);
      })
      .catch((e) => {
        return NotificationManager.error("something went wrong");
      });
  };

  useEffect(() => {
    if (!getMsmeCaid) return;
    msmeSchemesHandler();
  }, [getMsmeCaid, setSchemesData]);

  const getAllAdvisorUsers = () => {
    MainService.getAllMSMEConsumerUsers()
      .then((data) => {
        setMSMEUsers(data);
      })
      .catch((e) => {
        return NotificationManager.error("something went wrong");
      });
  };

  useEffect(() => {
    getAllAdvisorUsers();
  }, [setMSMEUsers]);

  const getAllMachineProviders = () => {
    MainService.getGlobalUsers("PMC")
      .then((data) => {
        setPMCUsers(data);
      })
      .catch((e) => {
        return NotificationManager.error("something went wrong");
      });
  };

  const getAllFMCMachineProviders = () => {
    MainService.getGlobalUsers("FMC")
      .then((data) => {
        setFMCUsers(data);
      })
      .catch((e) => {
        return NotificationManager.error("something went wrong");
      });
  };

  useEffect(() => {
    getAllMachineProviders();
    getAllFMCMachineProviders();
  }, [setPMCUsers, setFMCUsers]);

  const renderCardContent = (title, data) => (
    <CardContent>
      <Typography className={classes.title} color="textSecondary" gutterBottom>
        {title}
      </Typography>
      <Typography variant="h5" component="h2">
        {data?.length}
      </Typography>
    </CardContent>
  );

  return (
    <>
      <Card sx={{ mb: "1rem" }}>
        <Box sx={{ p: 2, display: "flex" }}>
          <Grid container spacing={0}>
            <Grid item md={12} xs={12}>
              <Grid container className={classes.gridRoot} spacing={2}>
                <Grid item md={4} xs={12}>
                  <Card className={classes.root} variant="outlined">
                    {renderCardContent("TOTAL MSME SCHEMES", getSchemesData)}
                  </Card>
                </Grid>
                <Grid item md={4} xs={12}>
                  <Card className={classes.root} variant="outlined">
                    {renderCardContent("TOTAL PMC MACHINES", getProductsLength)}
                  </Card>
                </Grid>
                <Grid item md={4} xs={12}>
                  <Card className={classes.root} variant="outlined">
                    {renderCardContent(
                      "TOTAL FMC MACHINES",
                      getFarmProductsLength
                    )}
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Card>
      <Card sx={{ mb: "1rem" }}>
        <Box sx={{ p: 2, display: "flex" }}>
          <Grid container spacing={0}>
            <Grid item md={12} xs={12}>
              <Grid container className={classes.gridRoot} spacing={2}>
                <Grid item md={4} xs={12}>
                  <Card className={classes.root} variant="outlined">
                    {renderCardContent(
                      "TOTAL PMC MACHINE PROVIDERS",
                      getPMCUsers
                    )}
                  </Card>
                </Grid>
                <Grid item md={4} xs={12}>
                  <Card className={classes.root} variant="outlined">
                    {renderCardContent(
                      "TOTAL FMC MACHINE PROVIDERS",
                      getFMCUsers
                    )}
                  </Card>
                </Grid>
                <Grid item md={4} xs={12}>
                  <Card className={classes.root} variant="outlined">
                    {renderCardContent("RAW PRODUCTS SOLD", [])}
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Card>
      <Card>
        <Box sx={{ p: 2, display: "flex" }}>
          <Grid container spacing={0}>
            <Grid item md={12} xs={12}>
              <Grid container className={classes.gridRoot} spacing={2}>
                <Grid item md={4} xs={12}>
                  <Card className={classes.root} variant="outlined">
                    {renderCardContent("AGRI ASSETS SOLD", [])}
                  </Card>
                </Grid>
                <Grid item md={4} xs={12}>
                  <Card className={classes.root} variant="outlined">
                    {renderCardContent("PROCESSED PRODUCTS SOLD", [])}
                  </Card>
                </Grid>
                <Grid item md={4} xs={12}>
                  <Card className={classes.root} variant="outlined">
                    {renderCardContent("TOTAL ADVISORS", getMSMEUsers)}
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Card>
    </>
  );
}
